import {createApplication} from '@angular/platform-browser';
import {appConfig} from './app/app.config';
import {createCustomElement} from "@angular/elements";
import {
  StartEmbeddedSignupButtonComponent
} from "./app/components/start-embedded-signup-button/start-embedded-signup-button.component";
import {DisplayMessagesComponent} from './app/components/display-messages/display-messages.component';
import {StartEmbeddedSignupComponent} from './app/components/start-embedded-signup/start-embedded-signup.component';
import {DisplayMessageComponent} from './app/components/display-message/display-message.component';
import * as Sentry from "@sentry/angular";
import {environment} from './app/environments/environment';

Sentry.init({
  dsn: environment.sentryDsn,
  environment: environment.environment,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

createApplication(appConfig).then(app => {
  console.info('Rabbit Messenger Onboarding : Initializing...');

  const appCustomElements: {
    name: string,
    constructor: CustomElementConstructor,
    options?: ElementDefinitionOptions,
  }[] = [];

  appCustomElements.push({
    name: 'start-embedded-signup',
    constructor: createCustomElement(StartEmbeddedSignupComponent, {injector: app.injector})
  });

  appCustomElements.push({
    name: 'start-embedded-signup-button',
    constructor: createCustomElement(StartEmbeddedSignupButtonComponent, {injector: app.injector})
  });

  appCustomElements.push({
    name: 'display-messages',
    constructor: createCustomElement(DisplayMessagesComponent, {injector: app.injector})
  });

  appCustomElements.push({
    name: 'display-message',
    constructor: createCustomElement(DisplayMessageComponent, {injector: app.injector})
  });

  appCustomElements.forEach(element => customElements.define(
    element.name,
    element.constructor,
    element.options
  ));

  console.info(`Rabbit Messenger Onboarding : Start-up complete, defined ${appCustomElements.length} custom element(s).`);
}).catch(error => console.error(error));
